import { MD5 } from 'crypto-js';
import { useRef } from 'react';
import { ButtonCancel, ButtonConfirm } from '../../utils/Button';
import { WarningIcon } from '../../utils/SVGIcon';

function Buttons({ confirm, setConfirm, buttons, loading }) {
    if (confirm.buttons) {
        return buttons.map((button, index) => (
            <div className="template-clickAction" key={MD5(index)}>
                {button}
            </div>
        ));
    }
    return (
        <div className="flex flex-row justify-center items-center gap-4">
            <ButtonCancel onClick={() => setConfirm(null)} title={confirm.textCancel || 'Cancel'} />

            <ButtonConfirm
                onClick={() => {
                    if (typeof confirm.clickAction === 'function') {
                        confirm.clickAction(confirm, setConfirm);
                    }
                }}
                title={confirm.textAction || 'Delete'}
                loading={loading}
            />
        </div>
    );
}

function ConfirmTemplate({ setConfirm, confirm, loading }) {
    // setConfirm
    const ref = useRef();
    const { icon, text, buttons, showButton = true, showIcon = true } = confirm || {};

    if (!confirm) {
        return null;
    }

    return (
        <div className="modal-box fixed bg-primary/50 top-0 left-0 px-4 w-full h-full flex flex-col justify-center items-center z-50">
            <div className="modal-box-content w-80 md:w-104 min-h-46 md:min-h-56 bg-white-100 p-5 md:p-7 rounded-3xl text-center">
                <div className="flex flex-col justify-center items-center gap-3 md:gap-5" ref={ref}>
                    {showIcon && (
                        <div className="size-10 md:size-12 text-warning">
                            {icon ? <img src={icon} alt="" className="block" /> : <WarningIcon />}
                        </div>
                    )}

                    <div className="font-medium text-sm md:text-base w-full text-center">
                        {text || '--'}
                    </div>

                    {showButton && (
                        <div className="flex flex-row justify-center items-center gap-4">
                            <Buttons
                                setConfirm={setConfirm}
                                confirm={confirm}
                                buttons={buttons}
                                loading={loading}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ConfirmTemplate;
